import React from 'react';
import './header.css';

const Header = () => (
  <header className="site-header">
    <div className="container header-inner">
      <a href="/" className="brand" aria-label="Igrecway Hangman home">
        Igrecway Hangman
      </a>
      <a
        href="https://apps.apple.com/app/id554531726?mt=8&ct=website_header"
        className="header-download"
      >
        Download free
      </a>
    </div>
  </header>
);

export default Header;
